import messages from "./messages.i18n";
import { useIntl } from "react-intl";
import EmbedCodeDimensions from "./SpaceEmbedCodeDimensions";
import EmbedCodeToggleSwitch from "./SpaceEmbedCodeToggleSwitch";
import EmbedCodeLayoutSize from "./SpaceEmbedCodeLayoutSize";
export var LayoutSize;
(function (LayoutSize) {
    LayoutSize["S"] = "S";
    LayoutSize["M"] = "M";
    LayoutSize["L"] = "L";
    LayoutSize["C"] = "Custom";
})(LayoutSize || (LayoutSize = {}));
export const LayoutSizeDimensions = {
    [LayoutSize.S]: {
        width: 450,
        height: 300,
    },
    [LayoutSize.M]: {
        width: 900,
        height: 600,
    },
    [LayoutSize.L]: {
        width: 1200,
        height: 800,
    },
    [LayoutSize.C]: {
        width: 0,
        height: 0,
    },
};
export const SpaceEmbedCodeFormInitialValues = {
    dimensions: LayoutSizeDimensions[LayoutSize.L],
    layoutSize: LayoutSize.L,
    showListingDetails: true,
    showRoomsMenu: true,
};
export const getSpaceEmbedCodeFormFields = () => {
    const intl = useIntl();
    return {
        layout: [
            {
                id: "layoutSize",
                label: intl.formatMessage(messages.spaceEmbedCodeFormLayoutSize),
                placeholder: "",
                required: false,
                component: EmbedCodeLayoutSize,
                columns: 6,
            },
            {
                id: "dimensions",
                label: "",
                placeholder: "",
                required: false,
                component: EmbedCodeDimensions,
                columns: 6,
            },
        ],
        listingConfig: [
            {
                id: "showListingDetails",
                label: intl.formatMessage(messages.spaceEmbedCodeFormShowListingDetails),
                placeholder: "",
                required: false,
                component: EmbedCodeToggleSwitch,
                columns: 6,
            },
            {
                id: "showRoomsMenu",
                label: intl.formatMessage(messages.spaceEmbedCodeFormShowRoomsMenu),
                placeholder: "",
                required: false,
                component: EmbedCodeToggleSwitch,
                columns: 6,
            },
        ],
    };
};
